<script>
import Modal from '../../components/Modal.vue'
import { debounce } from 'lodash'
import VueSelect from 'vue-select'

export default {
    components: {
        Modal,
        VueSelect,
    },

    props: {
        csrfToken: {
            type: String,
            required: true
        },
        jobPipeLineId: {
            type: Number,
            required: true,
            default: null
        }
    },

    computed: {
        filteredRequisitionJobs() {
            return this.requisitionJobs.filter(job => job && job.job && job.job.id !== this.jobPipeLineId)
        }
    },

    data() {
        return {
            requisitionJobs: [],
            selectedOption: '',
            requisition: null
        }
    },

    methods: {
        fetchRequisitionJobs(search = '', loading = null) {
            if (loading) loading(true);
            this.search(`/recruiter/active-requisitions/index.json?search=${search}&limit=1000&status=active`, loading, json => {
                this.requisitionJobs = json.requisitions;
                for (let i = 0; i < this.requisitionJobs.length; i++) {
                    if (this.requisitionJobs[i].job !== null) {
                        this.requisitionJobs[i].title = this.requisitionJobs[i].job.title;
                    } else {
                        this.requisitionJobs[i].title = this.requisitionJobs[i].display_name;
                    }
                }
            });
        },
        search: debounce((url, loading, mapResult) => {
            fetch(url).then(res => {
                res.json().then(mapResult);
                if (loading) loading(false);
            });
        }, 250),
        toggleModal() {
            this.$refs.modal.toggle()
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Convert To Requisition">
        <h1>Select active requisition to move candidate to</h1>

        <form method="POST"
            :action="`/recruiter/active-requisitions/convert-to-requisition/${jobPipeLineId}`">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />

            <div class="mb-4">
                <label>Pick Job</label>

                <input name="requisition_id" type="hidden" :value="requisition ? requisition.job.id : null" />

                <vue-select label="title" @search="fetchRequisitionJobs" @open="fetchRequisitionJobs"
                    :options="filteredRequisitionJobs" v-model="requisition">
                    <template slot="option" slot-scope="option">
                        {{ option.job !== null ? option.job.title : option.display_name }} (#{{ option.id }}, {{ option.person_specification.business_line.company.title }})
                    </template>
                </vue-select>
            </div>

            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink">
                    <button class="button primary" type="submit">Convert</button>
                </div>

                <div class="cell shrink">
                    <button @click="toggleModal" class="button warning" type="button">Close</button>
                </div>
            </div>
        </form>
    </modal>
</template>

<style>
.select-box {
    height: 50px;
    border-radius: 2px;
}
</style>